import { FC, PropsWithChildren } from 'react';
import styles from './Scrollable.module.css';

const Scrollable: FC<PropsWithChildren> = ({ children }) => <div className={styles.scrollable}>{children}</div>;

export default Scrollable;
